module.exports = __webpack_public_path__ + "static/img/index-carousel-05-02.9e262b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-carousel-05-02.png
// module id = /o+Q
// module chunks = 0